const MIDDLEWARE_URL: string = import.meta.env.VITE_MIDDLEWARE_URL;

export interface Voucher {
    code?: string,
    value?: number,
    type?: VoucherType,
}

export enum VoucherType {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  PERCENTAGE = "PERCENTAGE",
  SET_PRICE = "SET_PRICE"
};

export const validateVoucher = async (code: string, ticketId: string): Promise<any> => {
    try {
        const response = await fetch(`${MIDDLEWARE_URL}/vouchers/${code}/validate/${ticketId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.json();
    } catch (error) {
        console.error("Error: ", error)
        return error;
    }
}